/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

export const pickerDefaultProps = { cancelBtn: '取消', confirmBtn: '确认', header: true, visible: false };

export const pickerItemDefaultProps = { options: [] };
